import NeonHero from '../../components/NeonHero';
import FinancingBanner from '../../components/FinancingBanner';

export default function Tint() {
	return (
		<div>
			<NeonHero
				title="Window Tint"
				subtitle="Premium films with heat rejection and UV protection. Clean installs, lifetime warranty."
				primaryCta={{ label: 'Book Tint', href: 'https://realm.ubiquityauto.com/order/2dcf3188-0a07-4444-b5f8-065a5dc238bb?access_token=_ha6LYxaO-9HjbYZVCY7P21vuKFFRaQ5' }}
			/>

			<FinancingBanner />

			<section className="container py-12">
				<h2 className="text-2xl font-bold">Options</h2>
				<ul className="mt-4 grid sm:grid-cols-2 gap-3 text-gray-700 list-disc list-inside">
					<li>Dyed, carbon, and ceramic films</li>
					<li>Windshield strip and full ceramic</li>
					<li>Lifetime workmanship warranty</li>
					<li>Mobile or hub installation</li>
				</ul>
				<div className="mt-10 grid md:grid-cols-3 gap-6">
					<div className="rounded-xl border bg-white p-6 shadow-sm">
						<h3 className="font-semibold">Process</h3>
						<ol className="mt-2 list-decimal list-inside text-gray-700 space-y-1">
							<li>Tint selection and measurement</li>
							<li>Surface prep and dust control</li>
							<li>Install and cure</li>
							<li>Final inspection</li>
						</ol>
					</div>
					<div className="rounded-xl border bg-white p-6 shadow-sm">
						<h3 className="font-semibold">Financing</h3>
						<p className="mt-2 text-gray-700">0% APR plans available at checkout via Affirm/Klarna (OAC).</p>
					</div>
					<div className="rounded-xl border bg-white p-6 shadow-sm">
						<h3 className="font-semibold">Timeline</h3>
						<p className="mt-2 text-gray-700">Most vehicles done in 1–3 hours depending on film choice.</p>
					</div>
				</div>
			</section>
		</div>
	);
}
